export default `
// STEP 1 - Enter the form ID:
const formId = '';

// STEP 2 - Enter the field name:
const fieldName = '';

// STEP 3 - Enter the field value:
const fieldValue = '';



/////// PLEASE DO NOT MODIFY ANY CODE BELOW THIS LINE ///////



const form = document.getElementById(formId);

if (form) {
    const field = form.elements[fieldName];

    if (field) {
        field.value = fieldValue;
    }
}
`;
